import { render, staticRenderFns } from "./Projectcation.vue?vue&type=template&id=4c3dace3&scoped=true&"
import script from "./Projectcation.vue?vue&type=script&lang=js&"
export * from "./Projectcation.vue?vue&type=script&lang=js&"
import style0 from "./Projectcation.vue?vue&type=style&index=0&id=4c3dace3&scoped=true&lang=css&"
import style1 from "./Projectcation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dace3",
  null
  
)

export default component.exports